import React from 'react';

// Because react is obnoxious about putting key properties on everything.
// Make sure an array of react elements each has a key, i.e.
// [<a/>, <a/>].map(ensureKeyed('taco')) => [<a key='taco_1'/>, <a key='taco_2'/>]

/**
 * ensureKeyedNoTotal does not show a total so that when a new item is
 * added to a mapped component array, not every key is regenerated
 * causing every component in the list to be re-rendered.
 * */
const ensureKeyedNoTotal = (prefix = 'react_requires_keys') => 
  (item, i, list) => item.key ? item : React.cloneElement(item, { key: `${prefix}_${i}` });

export { ensureKeyedNoTotal };
export default (prefix = 'react_requires_keys') =>
  (item, i, list) => item.key ? item : React.cloneElement(item, { key: `${prefix}_${i}_of_${list.length}` });
